<template>
    <div class="d-flex flex-column">
      <subnav :links="subnav" heading="Настройки"/>
      <transition name="fade" mode="out-in">
        <router-view/>
      </transition>
    </div>
  </template>
  
  <script>
    export default {
      metaInfo: {title: 'Настройки'},
      data: () => ({
        subnav: [
          {
            text: 'Организации',
            to: '/billing/settings/regions',
            exact: true,
            permission: 'web_billing_settings',
          },
          {
            text: 'Команды',
            to: '/billing/settings/commands',
            permission: 'web_billing_settings',
          },
          {
            text: 'Внешние API',
            to: '/billing/settings/external-api',
            permission: 'web_billing_settings',
          },
        ],
      }),
    }
  </script>




// WEBPACK FOOTER //
// resources/assets/js/pages/billing/settings/index.vue